<div class="rc-list-container">
  @for (item of listItems; track item.key) {
    <div class="rc-list-item">
      <span>{{ item.key }}</span>
      @if (item.sanitize) {
        <span
          class="rc-list-item__value"
          [class.bold]="highlightValue"
          [appDataCSmask]="item.dataCSmask"
          [innerHTML]="item.value | safeHtml"
        >
        </span>
      } @else {
        <span class="rc-list-item__value" [class.bold]="highlightValue" [appDataCSmask]="item.dataCSmask">
          {{ item.value }}
        </span>
      }
    </div>
  }
</div>
